<template>
  <div @click="clickHandler">
    <div class="level">
      <div class="level-item">
        <slot></slot>
        <a :class="$mq.phone ? 'paragraph-s': 'paragraph'" class="dark-gray-link">{{ text }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clickHandler: {type: Function, default: () => {}},
    text: String
  }
};
</script>
